import {SET_CONTEXT, SET_CONTEXT_COMPANY, SET_CONTEXT_ZONE} from "../actions/context";

export default (state = {
  token: null,
  companyId: 1000, // hardcoded for mazda
  zoneId: 10 // hardcoded for mazda
}, action) => {
  const {type, payload} = action;

  switch (type) {
    case SET_CONTEXT:
      return {
        ...state,
        ...payload
      };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/context.js